import { CanActivateFn } from '@angular/router';

export const hasOrderGuard: CanActivateFn = (route, state) => {
  const orderId = route.params[ 'orderId' ]
  return orderId && orderId.length === 32;
};
